import React, { Component } from 'react';
import Helmet from 'react-helmet';

import { Link, withRouter } from 'react-router-dom';
import { lang } from '../../../il8n/lang';
import { connect } from 'react-redux';
import { changeProduct, toggleInterstitial } from '../../../Actions/Index';
import { mapATGLoc } from '../../../utils';
import { atgBase, atgProductDetailRoot, cdnBase } from '../../../const';
import GeneralModal from '../../GeneralModal/GeneralModal';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import WhereToBuy from '../../WhereToBuy/WhereToBuy';
import Accordion from '../../Accordion/Accordion';


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



import './Toy.css';

/**
 * Toy - Individual Toy Listing (PDP)
 * @constructor
 */

class Toy extends Component {
  constructor(props) {
    super(props);
    this.state = {
        ...props,
        modalOpen: false,
        splitCopy: true,
        iframeUrl: ""
    };

    


    this.toggleModal = this.toggleModal.bind(this);
    this.toggleReadMore = this.toggleReadMore.bind(this);
    this.openIFrameModal = this.openIFrameModal.bind(this);
  }

  
  componentWillMount() {
    this.populateProducts();
  }

  componentDidUpdate(){ 
    const e1 = document.getElementById('ps-iframe');
   if (e1 != null){
     e1.addEventListener('click', this.openIFrameModal, false);
   }
  }

  openIFrameModal = (e) => {
    this.props.dispatch(toggleInterstitial(true, this.iframeUrl, '', true));
  }

  /**
  * Populate the product.
  */
    
  populateProducts(){
    let _this = this;
    let requestedPid = this.props.match.params.pid;
    let loc = (mapATGLoc() === 'uk' ? 'gb': mapATGLoc())
    let feedUrl = `${atgBase}rest/service/sm/${loc}/catalog/ProductDetail/${requestedPid}?categories=true`;
    fetch(feedUrl).then(function(res) {
      let contentType = res.headers.get('content-type');
      if(contentType && contentType.indexOf('application/json') !== -1) {
        return res.json().then(function(json) {
          _this.props.dispatch(changeProduct(json));
        });
      } else {
        console.warn('Product Not Loaded');
      }
    });
  }
// Toggle MOdal
  toggleModal(vid){
    this.setState(state => ({
      modalOpen: !state.modalOpen,
      currentvid: vid
    }));
  }

// Toggle Read More
  toggleReadMore(){
    this.setState(state => ({
      splitCopy: !state.splitCopy
    }));
  }

  /**
  * Renders the Retailers.
  * @returns {jsx} retailers
  */
  getRetailers(){
    let {product} = this.props;
    if(product.retailers && product.retailers.length){
      return(
        <div>
          <h2>{lang.toy.retailers}</h2>
          <ul>
            {product.retailers.map((retailer, index) => (
              <a key={`feature-${index}`} href={retailer.link} target='_blank' rel='noopener noreferrer'>
                <img src={retailer.retailer.logo} alt={retailer.retailer.displayName}/>
              </a>
            ))}
          </ul>
        </div>
      )
    }
  }
  /**
  * Renders the CTA.
  * @returns {jsx} CTA button
  */
  getCta(){
    let {product} = this.props;

    // console.log('CTA PRODUCT', product)
    let buyNow, instructions, videoInstructions;

    if(product.price){
      buyNow = (
        <a target='_blank' rel='noopener noreferrer' href={atgProductDetailRoot + product.id}>
          <button>
            {lang.toy.buyNow}
          </button>
        </a>
      );
    }

    // TODO Need to find a product with docs
    if(product.instructions){
      instructions = (
        <a href={product.instructions}>
          <button>
            {lang.toy.instructions}
          </button>
        </a>
      );
    }

    // TODO Need to find a product with video instructions
    if(product.howToVideo){
      videoInstructions = (
        <a onClick={()=>this.toggleModal(product.howToVideo)}>
          <button>
            {lang.toy.videoInstructions}
          </button>
        </a>
      );
    }

    let hasChannelAdvisor = this.props.product.hasChannelAdvisor;

    let iframeButton = null;
    let priceSpider = null;

    if(hasChannelAdvisor == 'true'){
      let upc = this.props.product.id;
      this.iframeUrl = "https://where-to-buy.co/widgets/core/BuyOnlineBuyLocalV2/index.html?pid=12042547&model="+upc;
      
      
      iframeButton = (
          <div className="interstial-links iframe-section" ps-sku={this.props.product.id}>
              <span id='ps-iframe' className='ps-iframe'>Shop Retailers</span>
          </div>
      );
      
    }else{
      priceSpider = (
        <div className="ps-widget" ps-sku={this.props.product.id} ></div>
      );
      window.PriceSpider.rebind();
    }


    const isEnglish = lang.getLanguage() == 'en_us';

    if(isEnglish){
      return(
        <div className='row cta custom-spider'>
            {instructions}
            {videoInstructions}
            {buyNow}
            {hasChannelAdvisor == 'true' ? iframeButton : priceSpider}
        </div>
      )
    } else{
      return(
        <div className='row cta'>
            {instructions}
            {videoInstructions}
            {buyNow}
            {hasChannelAdvisor == 'true' ? iframeButton : null}
        </div>
      )
    }
  }
  /**
  * Renders the Product.
  * @returns {jsx} product
  */
  renderProduct(){
    let {product} = this.props;
    let images = [];

    const hasInstructions = product.find ? product.find((tag)=>{
        return tag.name === 'instruction_videos';
    }) : false

    if(product.images){
      for (let i = 0; i < product.images.length; i++){
        images.push(product.images[i].large);
      }
    }

    let sliderSettings = {
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: product.images.length < 5 ? product.images.length : 5,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: <button>
        <svg viewBox="0 0 16.7 29.2"><path className="st0" d="M0.6,0.6c0.7-0.7,1.9-0.8,2.7-0.1l0.1,0.1l12.7,12.6c0.7,0.7,0.8,1.9,0.1,2.7L16.1,16L3.4,28.6
          c-0.8,0.8-2,0.8-2.8,0c-0.7-0.7-0.8-1.9-0.1-2.7l0.1-0.1l11.3-11.2L0.6,3.4C-0.1,2.7-0.2,1.5,0.6,0.6L0.6,0.6z"/>
        </svg>
      </button>,
      prevArrow: <button>
        <svg viewBox="0 0 16.7 29.2"><path className="st0" d="M0.6,0.6c0.7-0.7,1.9-0.8,2.7-0.1l0.1,0.1l12.7,12.6c0.7,0.7,0.8,1.9,0.1,2.7L16.1,16L3.4,28.6
        c-0.8,0.8-2,0.8-2.8,0c-0.7-0.7-0.8-1.9-0.1-2.7l0.1-0.1l11.3-11.2L0.6,3.4C-0.1,2.7-0.2,1.5,0.6,0.6L0.6,0.6z"/>
        </svg>
      </button>
    };
    
    let featuresList = (
      (
      <>
        {product.featureList && product.featureList.split('|').map((feature, index) => (
          <span className="features-item">
          <li key={`feature-${index}`} className="features-list-items">{feature}</li>
          </span>
        ))}
      </>
       )
     )
 
     let contentsText = (
       <>
         {product.contents.split('|').map((content, index) => (
           <li key={`content-${index}`}><span className="content-item"></span>{content}</li>
         ))}
       </>
     )
    
    return(
      <div className='singletoy' itemType='http://schema.org/Product'>

        <div className='flex-row flex-container featured-image-container'>
          <div className='flex-col-sm-6'>
            <div className='featured-image' onClick={()=>{
              if(this.state.featureImg < product.images.length - 1){
                this.setState({featureImg: this.state.featureImg + 1});

              }else{
                this.setState({featureImg: 0});
              }

              }}>
              {product.images && (
                <img src={this.state.featureImg ? product.images[this.state.featureImg].large : product.images[0].large} alt={product.name}/>
              )}
            </div>

            {product.images.length > 0 &&  (
              <div className='product-images'>
                <Slider {...sliderSettings} className="slick-caro" >
                  {product.images.map((image, index) => {
                    return(
                      <img
                        // className='product-image'  
                        key={image.thumb} 
                        onClick={() => {
                          this.setState({featureImg : index});
                        }}  
                        src={image.large} 
                        alt={`${product.name} ${lang.toy.image} ${index + 1}`}
                      />
                    )
                  })}
                </Slider>
              </div>
            )}
            
          </div>
          <div className='flex-col-sm-6'>
            <h3 className='product-title desktop-h5 mobile-h5' itemProp='name'>{product.name}</h3>
            {/* <p itemProp='description'>{product.description}</p> */}
            {this.state.splitCopy === true ? 
            //  product.description.split(' ').splice(0, 50).join(' ')
            <div className="product-desc">
              {product.description && (
                <p className="desktop-body3 mobile-body3 toy-description">
                {product.description.split(' ').splice(0, 50).join(' ')}
                <div className="readMore desktop-body3 mobile-body3" onClick={()=> this.toggleReadMore()}>
                {lang.toy.readmore}
                </div>
              </p>
              )}
              
 
             </div>

                   : 
                   <p itemProp='description' className="desktop-body3 mobile-body3 product-desc">{product.description}</p> 
                  }
            {this.getCta()}
            {product.youTubeHowTo && (
              <div className="videoPlayer">
                <iframe src={`https://www.youtube.com/embed/${product.youTubeHowTo}?modestbranding=1&showinfo=0&rel=0&theme=light&color=white` } frameborder="0"></iframe>
              </div>
            )}

            <div className='button-bar'>
              { hasInstructions &&(
                <button className='cta blue' data-vid={ `${ cdnBase }videos/mp4/${ hasInstructions.description }` } onClick={ this.handleVideoClick }>
                  { lang.toy.videoInstructions }
                </button>)
              }
            </div>
          
          </div>
          
        </div>
        <div className="accordion__container">
          <Accordion features={lang.toy.features} featuresText={featuresList} contents={lang.toy.contents} contentsText={contentsText} />
        </div>
      </div>
    )
  }

  render() {
    let {product} = this.props;

    let productPage = null;
    if (product) {
      productPage = this.renderProduct()
    } else {
      productPage = <div className='loading'>{lang.loading}</div>;
    }
 
    

    return (
      <div className='toy '>

        <GeneralModal open={this.state.modalOpen} toggleModal={this.toggleModal}>
          <VideoPlayer
            type={'default'}
            activeVid={this.state.currentvid}
            warn={lang.warnings.enableIframes}
            autoPlay={true}
            loop = {false}

          />
        </GeneralModal>

        { product &&
          <Helmet title={product.name || 'Loading...' + lang.helmet.siteTitle} />
        }
        { productPage }
      
        <div className="section toys-where-to-buy" id="wheretobuy">
          <div className="section__bg section--bg toys-where-to-buy" style={{ background : `url("${cdnBase}Where-to-Buy-Background.jpg")`}}>
            <div className="section__topborder toys-where-to-buy-border" style={{ background : `url("${cdnBase}Tile_Black_Divider.png")`}}>
            </div>
            <div className="section__fg">
            <WhereToBuy/>
          </div>
          </div>
          
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let { lang, product } = state;
  return {
    lang,
    product
  };
}

export default withRouter(connect(mapStateToProps)(Toy));
